/*eslint no-use-before-define: "off" */

export const bannerOffset = () => {
  var timeout;

  var banner = $('.banner');
  var header = $('.page-header-js');
  var wpadminbar = $('#wpadminbar');

  window.bannerHeight = banner.outerHeight();
  window.headerHeight = header.outerHeight();
  window.scrollTrigger = window.bannerHeight;
  window.wpadminbarHeight = wpadminbar.outerHeight();

  // if(wpadminbar) {
  //   window.bannerHeight = banner.outerHeight() - window.wpadminbarHeight;
  // } else {
  //   window.bannerHeight = banner.outerHeight();
  // }

  calculateBannerHeight();
  offsetBodyBannerHeight();
  adjustHeaderImageHeight();

  $(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();
    if (scrollPosition > window.scrollTrigger) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  });

  $(window).resize(function() {
    clearTimeout(timeout);

    timeout = setTimeout(adjustBanner, 200);
  });

  function adjustBanner() {
    if(hasWpadminbarHeightChanged()) {
      window.wpadminbarHeight = wpadminbar.outerHeight();
    }

    if(hasBannerHeightChanged()) {
      calculateBannerHeight();

      window.scrollTrigger = window.bannerHeight;

      offsetBodyBannerHeight();
    }

    if(hasHeaderHeightChanged()) {
      window.headerHeight = header.outerHeight();

      adjustHeaderImageHeight();
    }
  }

  function calculateBannerHeight() {
    if(wpadminbar.length) {
      window.bannerHeight = banner.outerHeight() - window.wpadminbarHeight;
    } else {
      window.bannerHeight = banner.outerHeight();
    }
  }

  function offsetBodyBannerHeight() {
    // if($('body').hasClass('home')) {
    //   return false;
    // }

    // $('body').css('padding-top', window.bannerHeight + 'px');
  }

  function hasBannerHeightChanged() {
    var bannerHeight = banner.outerHeight();

    if( window.bannerHeight != bannerHeight ) {
      return true;
    } else {
      return false;
    }
  }

  function hasHeaderHeightChanged() {
    var headerHeight = header.outerHeight();

    if( window.headerHeight != headerHeight ) {
      return true;
    } else {
      return false;
    }
  }

  function hasWpadminbarHeightChanged() {
    var wpadminbarHeight = wpadminbar.outerHeight();

    if( window.wpadminbarHeight != wpadminbarHeight ) {
      return true;
    } else {
      return false;
    }
  }

  function adjustHeaderImageHeight() {
    // $('.page-header-large-image').css('height', (window.headerHeight + window.bannerHeight) + 'px');
  }
}



// WEBPACK FOOTER //
// ./scripts/navigation-onscroll.js